import { useState, useEffect } from "react";
import { getDiscountedPrice } from "../OurPackagesPageElements/OurPackageMainSection";
import CompareModal from "../OurPackagesPageElements/CompareModal";
import useIsMobile from "../../Hooks/IsmobileHook";
import AnimatedText from "../../AnimatedText";
import rbdLogo from "../../Assets/rbdLogo.png";
import cornerIcon from "../../Assets/cornerIcon.png";

import { useCart } from "../../Contexts/Cart.contexts";

// import "./TestPackageCss/TestPackageMainSectioin.css";
import { IoSearchOutline } from "react-icons/io5";
import png1 from "../../Assets/Medical doctor_ 1.png";

import PackageDetailsModal from "../OurPackagesPageElements/PackageDetailsModel";
import FloatingCompareBox from "../OurPackagesPageElements/FloatingCompareBox";
import { FaSearch } from "react-icons/fa";
import { GiHypodermicTest } from "react-icons/gi";

import { FaPhoneAlt } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { MdNoteAdd } from "react-icons/md";
import { getPackageList, getTestList } from "../../api/api";
import CustomPagination from "../../common/CustomPagination";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import toast from "react-hot-toast";
import CustomLoader from "../../common/loader/CustomLoader";
import { TruncateText } from "../../common/TruncateText";
import { useNavigate } from "react-router-dom";

import { FaFilter } from "react-icons/fa6";

const TestSkeletonCard = () => {
  return (
    <div className="packageCard mainPackageCard wide-card test-packageCard test-skeleton">
      <div className="skeleton skeleton-image"></div>
      <div className="skeleton skeleton-line"></div>
      <div className="skeleton skeleton-line short"></div>
      <div className="skeleton skeleton-button"></div>
    </div>
  );
};

export default function TestPackageMainSection() {
  const { addToCart, cartItems, setCartItems } = useCart();

  const [testList, setTestList] = useState([]); //testlist data store in state

  const [loading, setLoading] = useState(true);

  // console.log("display test Data", testList);

  const discount = 11;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 768 && width > 480) {
        setRenderMode("dropdown");
      } else if (width <= 480) {
        setRenderMode("dropdown");
      } else {
        setRenderMode("buttons");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    fetchTestListData();
    // fetchPackageListData();
  }, []);

  // function to fetch test list data
  const fetchTestListData = async () => {
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      Center_ID: "",
      search_key: "",
    };
    try {
      setLoading(true);
      const res = await getTestList(payload);
      const filterTests = res?.data?.data?.filter(
        (item) => item.Package === "N"
      );
      setTestList(filterTests || []);
    } catch (error) {
      console.error("Error fetching test list:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddToCart = (packageData) => {
    if (packageData?.service_id === cartItems?.service_id) {
      toast.error("Item already in cart");
    }
    addToCart({
      id: packageData.service_id,
      product: packageData?.service_name,
      price: packageData.price,
      quantity: 1,
    });
  };

  const [maxLen, setMaxLen] = useState(window.innerWidth < 430 ? 33 : 20);

  useEffect(() => {
    const handleResize = () => {
      setMaxLen(window.innerWidth < 430 ? 33 : 20);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderCard = (card, index) => {
    const isAdded =
      cartItems && cartItems.some((item) => item.id === card.service_id);
    const handleToggleCart = () => {
      if (isAdded) {
        // remove from cart
        setCartItems((prev) =>
          prev.filter((item) => item.id !== card.service_id)
        );
      } else {
        // add to cart
        // setCartItems((prev) => [...prev, { id: card.service_id, ...card }]);
        handleAddToCart(card);
        toast.success("Item Added to the Cart");
      }
    };
    return (
      <div key={index} className="carouselCardWrapper">
        <div className="packageCard mainPackageCard wide-card test-packageCard">
          <div className="cornerImage">
            <div className="upperCardText">
              <img className="logoimg" src={rbdLogo} alt="RBD logo" />
            </div>
            <img
              src={cornerIcon}
              alt="corner icon"
              style={{ width: "3.5rem" }}
            />
          </div>

          <div className="cardTitlePack mainpackageTitlePack testPackageCard">
            <h2 style={{ color: "gray", fontSize: "16px" }}>
              <TruncateText text={card?.service_name} maxLength={25} />
            </h2>
            <span
              style={{ color: "#555", fontSize: "0.8rem", marginBottom: "4px" }}
            >
              Test Key:{" "}
              <TruncateText text={card?.service_key} maxLength={maxLen} />
            </span>
          </div>

          <div className="testPackageMidSection">
            <div className="priceSection">
              <h3 style={{ margin: "0", color: "gray", fontSize: "1rem" }}>
                &#8377; {Number(card.price)}/-
              </h3>
            </div>

            <div className="copiLinkSection">
              <p
                onClick={() => handleCopyLink(card)}
                style={{
                  color: "#007bff",
                  // textDecoration: "underline",
                  cursor: "pointer",
                  marginTop: "6px",
                  fontSize: "13px",
                }}
              >
                🔗 {copiedId === card.service_id ? "Link Copied!" : "Copy Link"}
              </p>
            </div>
          </div>

          <div className="cardLowerSec">
            <button
              className="rbdButton"
              title="Click to View Details"
              onClick={() => handleViewDetails(card)}
            >
              <span className="btn-text">View Details</span>
            </button>

            <button
              className={`rbdButton addCartBtn ${isAdded ? "added" : ""}`}
              title={isAdded ? "Added" : "Item Added"}
              onClick={handleToggleCart}
            >
              <span className="btn-text">
                {isAdded ? "Added Item" : "Add to Cart"}
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  };

  const [activeTab, setActiveTab] = useState("All");
  const [filters, setFilters] = useState({
    fasting: "",
    gender: "",
    ageRange: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 24;
  const [searchResults, setSearchResults] = useState(null);
  const [testType, setTestType] = useState("all");
  const navigate = useNavigate();
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showSortDropdown, setShowSortDropdown] = useState(false);

  const categories = [
    "All",
    "Heart",
    "Kidney",
    "Lungs",
    "Thyroid",
    "Liver",
    "Spinal Disc",
  ];

  const servicesDummy = [
    { title: "BIOCHEMISTRY", dept: "Biochemistry" },
    { title: "HAEMATOLOGY", dept: "Haematology" },
    { title: "HISTOPATHOLOGY", dept: "Histopathology" },
    { title: "MICROBIOLOGY", dept: "Medical Microbiology" },
    { title: "SEROLOGY", dept: "Serology" },
    { title: "CYTOLOGY", dept: "Cytology" },
    // { title: "CLINICAL PATHOLOGY", dept: "Clinical Pathology" },
  ];
  const [selectedDept, setSelectedDept] = useState("All");

  const applyFilters = (cards) => {
    return cards.filter((card) => {
      const { fasting, gender, ageRange } = filters;
      return (
        (fasting ? card.fasting === fasting : true) &&
        (gender ? card.gender === gender : true) &&
        (ageRange ? card.ageRange === ageRange : true)
      );
    });
  };

  const handleResetFilters = () => {
    setTestType("all");
    setSearchQuery("");
    setSearchResults(null);
    setCurrentPage(1);
  };

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // Apply department filter (if selected) to the base list (search results or full test list)
  const baseList = searchResults !== null ? searchResults : testList;
  const filteredBase =
    selectedDept && selectedDept !== "All"
      ? baseList.filter((card) => {
          const deptField = (
            card?.Department ||
            card?.department ||
            ""
          ).toString();
          return deptField.toLowerCase() === selectedDept.toLowerCase();
        })
      : baseList;

  function filterByTestType(cards) {
    if (testType === "single") {
      return cards.filter((card) => card.Package == "N");
    } else if (testType === "package") {
      return cards.filter((card) => card.Package == "Y");
    }
    return cards;
  }

  function sortByPrice(cards) {
    if (testType === "ascending") {
      return [...cards].sort((a, b) => (a.price || 0) - (b.price || 0));
    } else if (testType === "descending") {
      return [...cards].sort((a, b) => (b.price || 0) - (a.price || 0));
    }
    return cards;
  }

  const filteredByType = filterByTestType(filteredBase);
  const filteredAndSorted = sortByPrice(filteredByType);

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  const displayCards = filteredAndSorted.slice(
    indexOfFirstCard,
    indexOfLastCard
  );
  const totalPages = Math.ceil(filteredAndSorted.length / cardsPerPage);

  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleViewDetails = (card) => {
    // const cardWithToggle = {
    //     ...card,
    //     TestsAndComp: card.TestsAndComp.map((test) =>
    //         typeof test === 'string'
    //             ? {
    //                 name: test,
    //                 department: 'SEROLOGY',
    //                 reportTime: 0,
    //                 preparation: 'No special preparation',
    //                 serviceKey: `Service Key for ${test}`,
    //                 showDetails: false
    //             }
    //             : test
    //     ),
    //     toggleTest: (index) => {
    //         const updated = [...card.TestsAndComp];
    //         updated[index].showDetails = !updated[index].showDetails;
    //         setSelectedPackage({ ...cardWithToggle, TestsAndComp: updated });
    //     }
    // };
    // setSelectedPackage(cardWithToggle);
    setSelectedPackage(card);
    setIsModalOpen(true);
  };

  const [compareList, setCompareList] = useState([]);
  const [isCompareModalOpen, setIsCompareModalOpen] = useState(false);
  const [showCompareModal, setShowCompareModal] = useState(false);

  const handleToggleCompare = (selectedCard) => {
    const alreadyInList = compareList.some(
      (c) => c.title === selectedCard.title
    );
    if (alreadyInList) {
      setCompareList(compareList.filter((c) => c.title !== selectedCard.title));
    } else {
      setCompareList([...compareList, selectedCard]);
    }
  };

  const [searchQuery, setSearchQuery] = useState("");

  // Search by service_name from API data (case-insensitive)
  const handleSearch = (query) => {
    const trimmedQuery = query.trim();
    setSearchQuery(query);

    if (!trimmedQuery) {
      setSearchResults(testList);
      setCurrentPage(1);
      return;
    }

    const lowerQuery = trimmedQuery.toLowerCase();
    const filteredCards = testList.filter((card) =>
      (card?.service_name || "").toLowerCase().includes(lowerQuery)
    );

    setSearchResults(filteredCards);
    setCurrentPage(1);
  };

  const handleCompare = (e) => {
    e.preventDefault();

    if (compareList.length < 2 || compareList.length > 3) {
      alert(`Select a minimum of 2 and a maximum of 3 packages to compare.`);
      return;
    }
    setShowCompareModal(true);
    setIsCompareModalOpen(false);
  };

  const [renderMode, setRenderMode] = useState("buttons");

  // 'all', 'single', 'package'
  // const displayCards = searchResults !== null ? searchResults : currentCards;

  useEffect(() => {
    setSearchResults(null);
  }, [filters, activeTab]);
  // function for checking test type
  // const filterByTestType = (cards) => {
  //   console.log("cards", cards);
  //   if (testType === "single") {
  //     return cards.filter((card) => card.Package == "N");
  //   } else if (testType === "package") {
  //     return cards.filter((card) => card.Package == "Y");
  //   }
  //   return cards;
  // };

  // displayCards is now filtered and paginated above

  const handleClearSearch = () => {
    setSearchQuery("");
    setSearchResults(null);
  };

  const healthPackage = () => {
    navigate("/OurPackagesPage");
  };

  const [copiedId, setCopiedId] = useState(null);

  const handleCopyLink = async (card) => {
    // const link = `${window.location.origin}/RBD/test-packages/${card.service_id}`;

    // const link = `${window.location.origin}/rbweb-react/test-packages/${card.service_id}`;
    const link = `${window.location.origin}/test-packages/${card.service_id}`;


    try {
      await navigator.clipboard.writeText(link);
      setCopiedId(card.service_id);

      setTimeout(() => {
        setCopiedId(null);
      }, 3000);
    } catch (err) {
      console.error("Failed to copy link", err);
    }
  };
  const departments = [
    "All",
    ...new Set(servicesDummy.map((item) => item.dept)),
  ];

  return (
    <>
      <div className="ourPackageContainer testPackageContainer">
        {/* <div className="ourPackageUpperSection">
          <AnimatedText tag="h2" type="words" y={30} className="rb-title">
            Comprehensive Diagnostic Tests
          </AnimatedText>

          <p className="paraText">
            At RB Diagnostic, we offer an extensive range of tests covering all
            major health parameters. From routine screenings to advanced
            diagnostics,{" "}
          </p>
          <p className="paraText">
            our tests are designed to deliver accurate results with the highest
            precision—empowering you and your doctor to make informed health
            decisions at every step.
          </p>
        </div> */}

        {/* <div className="midNavButtons">
          {renderMode === "dropdown" ? (
            <select
              className="mobileDropdown"
              value={activeTab}
              onChange={(e) => {
                setActiveTab(e.target.value);
                setCurrentPage(1);
              }}
            >
              {categories.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
          ) : (
            <div
              className={`buttonContainer ${
                renderMode === "singleColumn" ? "columnView" : ""
              }`}
            >
              {categories.map((category) => (
                <button
                  key={category}
                  className={`navBtn ${activeTab === category ? "active" : ""}`}
                  onClick={() => {
                    setActiveTab(category);
                    setCurrentPage(1);
                  }}
                >
                  {category}
                </button>
              ))}
            </div>
          )}
        </div> */}

        <div className="searchBarWrapper">
          <GiHypodermicTest
            className="inputIcon"
            style={{ marginLeft: "1rem" }}
          />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Search for tests"
          />
          {searchQuery && (
            <CloseOutlinedIcon
              fontSize="small"
              style={{ color: "red" }}
              onClick={handleClearSearch}
            />
          )}
          <SearchOutlinedIcon fontSize="medium" style={{ color: "gray" }} />

          {/* <button
                        className="rbdButton"
                        onClick={() => handleSearch(searchQuery)}>
                        <span className="btn-text"> <FaSearch className="searchIcontest" /> Search</span>
                    </button> */}
        </div>

        <div className="testBodySection ">
          <div className="packageBodyLeftSection">
            {isMobile ? (
              <>
                <div className="mobileTestButtons">
                  <div className="mobile-option">
                    <div className="mobile-option-icon">
                      <FaPhoneAlt size={20} color="#f56a00" />
                    </div>
                    <div className="mobil-option-right">
                      <div className="mobile-option-text">
                        <strong>Call our Patient Support team to book</strong>
                        <p>Our team will help and guide you</p>
                      </div>
                      <IoIosArrowForward size={20} />
                    </div>
                  </div>

                  <div className="mobile-option">
                    <div className="mobile-option-icon">
                      <FaWhatsapp size={24} color="#25d366" />
                    </div>
                    <div className="mobil-option-right">
                      <div className="mobile-option-text">
                        <strong>Book through WhatsApp</strong>
                        <p>to book a test, say Hi</p>
                      </div>
                      <IoIosArrowForward size={20} />
                    </div>
                  </div>
                </div>
              </>
            ) : // <>
            //   {/* FILTERS */}
            //   <div className="filterSection">
            //     <div className="filterHeader">
            //       <p style={{ margin: 0, fontSize: "16px" }}>Filter By</p>
            //       {/* <IoSearchOutline
            //         size={20}
            //         style={{
            //           width: "1.5rem",
            //           height: "1.5rem",
            //           backgroundColor: "#01CAB8",
            //           borderRadius: "50%",
            //           padding: "5px",
            //         }}
            //       /> */}
            //     </div>

            //     <hr />

            //     <label htmlFor="all" className="filter-class">
            //       <input
            //         style={{ marginRight: "1.5rem" }}
            //         type="radio"
            //         id="single"
            //         name="testType"
            //         value="all"
            //         checked={testType === "all"}
            //         onChange={() => setTestType("all")}
            //       />
            //       All({testList.length})
            //     </label>

            //     <label htmlFor="all" className="filter-class">
            //       <input
            //         style={{ marginRight: "1.5rem" }}
            //         type="radio"
            //         id="single"
            //         name="testType"
            //         value="single"
            //         checked={testType === "single"}
            //         onChange={() => setTestType("single")}
            //       />
            //       Single Test
            //     </label>

            //     {/* <label htmlFor="all" className="filter-class">
            //       <input
            //         style={{ marginRight: "1.5rem" }}
            //         type="radio"
            //         id="package"
            //         name="testType"
            //         value="package"
            //         checked={testType === "package"}
            //         onChange={() => setTestType("package")}
            //       />
            //       Package
            //     </label> */}

            //     <div
            //       className="filterButtonsSec"
            //       style={{ display: "flex", justifyContent: "flex-end" }}
            //     >
            //       <button
            //         className="rbdButton reset-Btn"
            //         onClick={handleResetFilters}
            //       >
            //         <span className="btn-text">Reset</span>
            //       </button>
            //     </div>
            //   </div>
            // </>
            null}

            {/* <div className="filterSection">
              <div className="filterHeader">
                <p style={{ margin: 0, fontSize: "16px" }}>Sort By</p>
              </div>
              <hr />
              <label htmlFor="all" className="filter-class">
                <input
                  style={{ marginRight: "1.5rem" }}
                  type="radio"
                  id="ascending"
                  name="ascending"
                  value="ascending"
                  checked={testType === "ascending"}
                  onChange={() => setTestType("ascending")}
                />
                Price: Ascending
              </label>

              <label htmlFor="all" className="filter-class">
                <input
                  style={{ marginRight: "1.5rem" }}
                  type="radio"
                  id="descending"
                  name="testType"
                  value="descending"
                  checked={testType === "descending"}
                  onChange={() => setTestType("descending")}
                />
                Price: Descending
              </label>

              <div className="filterButtonsSec">
                <button
                  className="rbdButton reset-Btn"
                  onClick={handleResetFilters}
                >
                  <span className="btn-text">Reset</span>
                </button>
              </div>
            </div>

            <div className="mainLeftDoctorImage">
              <img src={png1} alt="Doctor png" />
            </div> */}
          </div>

          {/* Department tabs - below search bar */}
          <div className="midNavButtons  test-package-tabs">
            <div className="buttonContainer">
              {departments.map((dept) => (
                <button
                  key={dept}
                  className={`navBtn ${selectedDept === dept ? "active" : ""}`}
                  onClick={() => {
                    setSelectedDept(dept);
                    setCurrentPage(1);
                    // clear searchResults so filtering is applied fresh
                    setSearchResults(null);
                  }}
                >
                  {dept}
                </button>
              ))}
            </div>
          </div>

          {!isMobile && (
            <div className="desktopTopBar">
              <div className="filter-sortby">
                {/* FILTER BUTTON */}
                {/* <button
                className="topBarBtn"
                onClick={() => setShowFilterModal(true)}
              >
                <img src="/icons/filter.svg" className="topBarIcon" />
                <span>Filter</span>
              </button> */}
                <div>
                  {/* Filter Icon */}
                  <div className="filters-Section">
                    {/* <label htmlFor="sort-select">Filter:</label> */}
                    <button
                      onClick={() => setShowFilterModal(true)}
                      className="filter-btn"
                    >
                      Filter: <FaFilter className="filter-icon" />
                    </button>
                  </div>
                </div>

                {/* SORT BUTTON */}
                <div className="sortWrapper">
                  {/* <button
                  className="topBarBtn"
                  onClick={() => setShowSortDropdown((prev) => !prev)}
                >
                  <img src="/icons/sort.svg" className="topBarIcon" />
                  <span>Sort</span>
                </button> */}

                  {/* SORT DROPDOWN */}
                  {/* {showSortDropdown && (
                  <div className="sortDropdown">

                    <div className="dropdownHeader">Sort By</div>

                    <label className="dropdownOption">
                      <input
                        type="radio"
                        value="ascending"
                        checked={sortBy === "ascending"}
                        onChange={() => {
                          setSortBy("ascending");
                          handleApplySort("ascending");
                        }}
                      />
                      Price: Low → High
                    </label>

                    <label className="dropdownOption">
                      <input
                        type="radio"
                        value="descending"
                        checked={sortBy === "descending"}
                        onChange={() => {
                          setSortBy("descending");
                          handleApplySort("descending");
                        }}
                      />
                      Price: High → Low
                    </label>

                    <button
                      className="dropdownResetBtn"
                      onClick={() => {
                        setSortBy("");
                        handleResetFilters();
                      }}
                    >
                      Reset Sort
                    </button>
                  </div>
                )} */}

                  <div className="sort-dropdown">
                    <label htmlFor="sort-select">Sort By:</label>
                    <select
                      id="sort-select"
                      // value={sortBy}
                      value={testType}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        // setSortBy(newValue);
                        setTestType(newValue);
                        // handleApplyFilters(newValue);
                      }}
                    >
                      <option value="">Default</option>
                      <option name="ascending" value="ascending">
                        Price (Ascending)
                      </option>
                      <option name="testType" value="descending">
                        Price (Descending)
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="hp-button">
                <button onClick={healthPackage} className="rbdButton">
                  <span className="btn-text">Health Package</span>
                </button>
              </div>
            </div>
          )}

          <div className="mainPackageCardSection testPackageCardSection">
            {/* {loading ? (
              <div style={{ textAlign: "" }}>
                <CustomLoader />
              </div>
            ) : (
              displayCards.map((card, index) => renderCard(card, index))
            )}
             */}
            {loading
              ? Array.from({ length: 8 }).map((_, index) => (
                  <TestSkeletonCard key={index} />
                ))
              : displayCards.map((card, index) => renderCard(card, index))}
            <PackageDetailsModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              packageData={selectedPackage}
            />
          </div>
        </div>
        <div className="paginationTestSection">
          <CustomPagination
            totalPages={totalPages}
            currentPage={currentPage}
            onChange={handlePageChange}
          />
        </div>
      </div>

      <FloatingCompareBox
        compareList={compareList}
        onCompareClick={handleCompare}
      />

      {showCompareModal && (
        <CompareModal
          compareList={compareList}
          onClose={() => setShowCompareModal(false)}
        />
      )}

      {/* FILTER POPUP (DESKTOP) */}
      {showFilterModal && !isMobile && (
        <div
          className="filterModalOverlay"
          onClick={() => setShowFilterModal(false)}
        >
          <div className="filterModal" onClick={(e) => e.stopPropagation()}>
            <h3>Filter By</h3>

            <label className="modalOption">
              <input
                type="radio"
                name="testType"
                value="all"
                checked={testType === "all"}
                onChange={() => setTestType("all")}
              />
              All ({testList.length})
            </label>

            <label className="modalOption">
              <input
                type="radio"
                name="testType"
                value="single"
                checked={testType === "single"}
                onChange={() => setTestType("single")}
              />
              Single Test
            </label>

            <button className="modalResetBtn" onClick={handleResetFilters}>
              Reset
            </button>

            <button
              className="modalCloseBtn"
              onClick={() => setShowFilterModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
